import { ReactElement } from 'react';
import { Button } from 'antd';
import { styled } from 'styled-components';

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;

interface Props {
  onCancel: () => void;
}

const Buttons = ({ onCancel }: Props): ReactElement => {
  return (
    <ButtonRow>
      <Button type='primary' htmlType='submit'>
        編集
      </Button>
      <Button onClick={onCancel}>キャンセル</Button>
    </ButtonRow>
  );
};

export default Buttons;
